var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1128 12L19.1128 16.4444C19.1128 18.1206 19.1128 18.9586 18.5921 19.4793C18.0714 20 17.2334 20 15.5573 20L7.11284 20C5.88554 20 4.89062 19.0051 4.89062 17.7778V17.7778C4.89062 16.5505 5.88555 15.5556 7.11285 15.5556L15.5573 15.5556C17.2334 15.5556 18.0714 15.5556 18.5921 15.0349C19.1128 14.5142 19.1128 13.6761 19.1128 12L19.1128 7.55556C19.1128 5.87945 19.1128 5.0414 18.5921 4.5207C18.0715 4 17.2334 4 15.5573 4L8.44618 4C6.77008 4 5.93202 4 5.41132 4.5207C4.89062 5.0414 4.89062 5.87945 4.89062 7.55556L4.89062 17.7778",
    stroke: "white",
    strokeWidth: 1.77778
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 8.44531L14.6693 8.44531",
    stroke: "white",
    strokeWidth: 1.77778,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryWhite);
export default __webpack_public_path__ + "static/media/history-white.e1346ce94877ccec756c44397a67f7bd.svg";
export { ForwardRef as ReactComponent };